export default "__VITE_ASSET__37480bb2__"